export const regionToValueMap = {
	aus: 'Australia',
	aut: 'Austria',
	bel: 'Belgium',
	can: 'Canada',
	den: 'Denmark',
	fra: 'France',
	ger: 'Germany',
	int: 'International',
	ita: 'Italy',
	lux: 'Luxembourg',
	ned: 'Netherlands',
	swe: 'Sweden',
	che: 'Switzerland',
	tur: 'Turkey',
	gbr: 'United Kingdom',
	usa: 'USA'
};
